import { myyjanaAlvVelvollisetTilat } from '@lemon/core-firebase/model/kayttaja'
import { Laskuasetukset } from '@lemon/core-firebase/model/lasku'
import { YtjAsiakasRekisteriData } from 'app/_jaettu-lemonator/model/asiakas'

export type AlvRekisterinTila = 'kylla' | 'ei' | 'ei-tiedossa'

/**
 * Asiakkaan alv-rekisteröinti YTJ:n rekisteritiedoista. Viimeisin arvonlisäverovelvollisuuden rivi ratkaisee, kuten
 * asiakkaan tietojen viennissä Lemonaidiin, joten rekisteröinnin päättänyt rivi kumoaa aiemman rekisteröinnin.
 */
export function annaAlvRekisterinTila(rekisterit: YtjAsiakasRekisteriData[] | null | undefined): AlvRekisterinTila {
  if (!rekisterit?.length) {
    return 'ei-tiedossa'
  }
  const viimeisinAlvRekisteri = rekisterit.filter(rekisteri => rekisteri.nimi === 'Arvonlisäverovelvollisuus').at(-1)
  if (!viimeisinAlvRekisteri) {
    return 'ei'
  }
  return myyjanaAlvVelvollisetTilat.some(tila => tila === viimeisinAlvRekisteri.tila) ? 'kylla' : 'ei'
}

export function annaLaskutusprofiilinNimi(laskutusprofiili: Pick<Laskuasetukset, 'laskutusprofiilinNimi' | 'nimi'>): string {
  return laskutusprofiili.laskutusprofiilinNimi || laskutusprofiili.nimi
}

/** Asiakkaan oma laskutusprofiili (avaimena asiakkaan avain) ensin, muut nimen mukaan. */
export function jarjestaLaskutusprofiilit<T extends Pick<Laskuasetukset, 'avain' | 'laskutusprofiilinNimi' | 'nimi'>>(laskutusprofiilit: T[], asiakasAvain: string): T[] {
  const oma = laskutusprofiilit.filter(laskutusprofiili => laskutusprofiili.avain === asiakasAvain)
  const muut = laskutusprofiilit.filter(laskutusprofiili => laskutusprofiili.avain !== asiakasAvain).sort((a, b) => (annaLaskutusprofiilinNimi(a) ?? '').localeCompare(annaLaskutusprofiilinNimi(b) ?? '', 'fi'))
  return [...oma, ...muut]
}
